export default __webpack_public_path__ + "static/media/full-image.6cc5bc99.png";